// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PlanGroupEditController = function ($rootScope, $scope, $location, $routeParams, PlanGroup, ProductInfo, TaxPolicy, gettext, gettextCatalog, salesEntitiesService) {
    var initialPriceTaxType = 'Net';
    var initialBillingPrecision = 'Precise';
    var isNew = true;

    $scope.salesEntities = [];
    $scope.salesEntityId = null;
    $scope.salesEntityDefault = null;

    if ($routeParams.planGroupId) {
        $scope.productInfo = ProductInfo.get(function() {
            PlanGroup.get({planGroupId: $routeParams.planGroupId}).$promise.then(function (result) {
                $scope.planGroup = result;
                initialPriceTaxType = result.PriceTaxType;
                initialBillingPrecision = result.TimeGranularity;
                isNew = false;
                initSalesEntity();
            });
        });
    } else {
        $scope.productInfo = ProductInfo.get(function() {
            $scope.planGroup = new PlanGroup();
            $scope.planGroup.PriceTaxType = 'Net';
            $scope.planGroup.Currency = 'EUR';
            $scope.planGroup.TimeGranularity = 'Precise';
            initSalesEntity();
        });
    }
    TaxPolicy.query().$promise.then(function (result) {
        $scope.taxPolicies = result;
        $scope.planGroup.TaxPolicyId = TaxPolicy.getDefaultTaxPolicyId($scope.taxPolicies);
        $scope.planGroup.SetupTaxPolicyId = TaxPolicy.getDefaultTaxPolicyId($scope.taxPolicies); 
    });

    function initSalesEntity() {
        salesEntitiesService.query({}, function (response) {
            $scope.salesEntities = response;
            $scope.salesEntityDefault = response.find(function (el) {
                return el.IsDefault == true;
            });
            if ($scope.salesEntityDefault) {
                let defaultSuffix = " (" + gettextCatalog.getString(gettext('default')) + ")";
                $scope.salesEntityDefault.InternalName += defaultSuffix;

                if ($scope.planGroup && $scope.planGroup.SalesEntityId != null) {
                    $scope.salesEntityId = $scope.planGroup.SalesEntityId;
                } else {
                    $scope.salesEntityId = $scope.salesEntityDefault.Id;
                }
            }
        });
    }

    function finish() {
        $location.path("/plangroups");
    }

    $scope.save = function () {

        if ($scope.salesEntityId) {
            $scope.planGroup.SalesEntityId = $scope.salesEntityId;
        }

        if (!$rootScope.isValid($scope.form))
            return;
        if ($routeParams.planGroupId)
            $scope.planGroup.$update({ planGroupId: $routeParams.planGroupId }, finish);
        else
            $scope.planGroup.$save({}, finish);
    };

    $scope.showPriceTaxTypeChangedInfoBox = function (newVal) {
        if(!isNew)
        {
            $scope.priceTaxTypeWasChanged = initialPriceTaxType !== newVal;
        }
    };

    $scope.showBillingPrecisionChangedInfoBox = function (newVal) {
        if (!isNew) {
            $scope.billingPrecisionWasChanged = initialBillingPrecision !== newVal;
        }
    };

    $scope.cancel = finish;
};
PlanGroupEditController.$inject = ['$rootScope', '$scope', '$location', '$routeParams', 'PlanGroup', 'ProductInfo', 'TaxPolicy', 'gettext', 'gettextCatalog', 'SalesEntities'];
